import { Component, h, Element, Prop, Build, State } from '@stencil/core';
import { options as loqateOptions } from "../../shared/config-loqate"
import { countries, getCountry } from "../../shared/data-countries";
import { loadRemoteResource } from '../../shared/helpers'
import get from 'lodash/get';
declare var pca;

@Component({
    tag: 'app-address-search',
})
export class AppAddressSearch {

    @Element() dom: HTMLElement;
    @Prop() errors: any;
    @Prop() onChange: any;
    @State() timezoneCountry: string;

    // Address Search
    loqate: any = {}

    async componentWillLoad() {
        this.timezoneCountry = getCountry();
    }

    async componentDidLoad() {

        if (!Build.isBrowser) return;

        await loadRemoteResource('text/css', 'https://services.postcodeanywhere.co.uk/css/address-3.97.css')
        await loadRemoteResource('text/javascript', 'https://services.postcodeanywhere.co.uk/js/address-3.97.js')

        try {
            if (pca == null) return;
        }
        catch {
            return;
        }

        // bind loqate
        const dom: any = this.dom;
        const fields = [
            { element: "line-1", field: "", mode: pca.fieldMode.SEARCH }
        ];

        // Info: enables autocomplete on the search box
        (loqateOptions as any).suppressAutocomplete = false;

        this.loqate = new pca.Address(fields, loqateOptions);
        this.loqate.listen("populate", (result) => {
            if (result.Company) {
                dom.querySelector('input[name="line-1"]').value = result.Company
                dom.querySelector('input[name="line-2"]').value = result.Line1 || result.Line2 || result.Neighbourhood
                dom.querySelector('input[name="city"]').value = result.City
                dom.querySelector('input[name="county"]').value = result.CountryName
                dom.querySelector('input[name="postcode"]').value = result.PostalCode
            }
            else {
                dom.querySelector('input[name="line-1"]').value = result.Line1
                dom.querySelector('input[name="line-2"]').value = result.Line2 || result.Neighbourhood
                dom.querySelector('input[name="city"]').value = result.City
                dom.querySelector('input[name="county"]').value = result.CountryName
                dom.querySelector('input[name="postcode"]').value = result.PostalCode
            }
        })
    }

    disconnectedCallback() {
        if (!Build.isBrowser || Object.keys(this.loqate).length == 0) return;
        this.loqate.destroy();
    }

    render() {
        return (
            <div>
                <div class="uk-width-1-1">
                    <div class="uk-margin">
                        <label class="uk-form-label" >Country <span class="uk-text-danger">{get(this.errors, 'country.message')}</span></label>
                        <div class="uk-form-controls">
                            <input class="uk-input" id="form-stacked-text" type="text" list="data-countries" name='country' placeholder="Country" value={this.timezoneCountry} />
                            <datalist id="data-countries">
                                {
                                    countries.map((country) => <option value={country} />)
                                }
                            </datalist>
                        </div>
                    </div>
                </div>

                <div class="uk-width-1-1">
                    <div class="uk-margin">
                        <label class="uk-form-label" >Address <span class="uk-text-danger">{get(this.errors, 'line-1.message')}</span></label>
                        <div class="uk-form-controls">
                            <div class="uk-inline uk-width-1-1">
                                <span class="uk-form-icon uk-form-icon-flip" uk-icon="icon: search"></span>
                                <input class={`uk-input ${get(this.errors, 'line-1') ? 'uk-form-danger' : ''}`} name='line-1' placeholder="Address Line 1" type="text" onChange={this.onChange.bind(this)} />
                            </div>
                        </div>
                    </div>
                </div>

                <div class="uk-width-1-1">
                    <div class="uk-margin">
                        <label hidden={!get(this.errors, 'line-2.message')} class="uk-form-label">Address Line 2 <span class="uk-text-danger">{get(this.errors, 'line-2.message')}</span></label>
                        <div class="uk-form-controls">
                            <input class={`uk-input ${get(this.errors, 'line-2') ? 'uk-form-danger' : ''}`} name='line-2' type="text" placeholder="Address Line 2" onChange={this.onChange.bind(this)} />
                        </div>
                    </div>
                </div>

                <div class="uk-width-1-1">
                    <div class="uk-margin">
                        <label hidden={!get(this.errors, 'city.message')} class="uk-form-label">Town/City <span class="uk-text-danger">{get(this.errors, 'city.message')}</span></label>
                        <div class="uk-form-controls">
                            <input class={`uk-input ${get(this.errors, 'city') ? 'uk-form-danger' : ''}`} name='city' type="text" placeholder="Town/City" onChange={this.onChange.bind(this)} />
                        </div>
                    </div>
                </div>
                <div class="uk-width-1-1">
                    <div class="uk-margin">
                        <label hidden={!get(this.errors, 'county.message')} class="uk-form-label">County <span class="uk-text-danger">{get(this.errors, 'county.message')}</span></label>
                        <div class="uk-form-controls">
                            <input class={`uk-input ${get(this.errors, 'county') ? 'uk-form-danger' : ''}`} name='county' type="text" placeholder="County" onChange={this.onChange.bind(this)} />
                        </div>
                    </div>
                </div>

                <div class="uk-width-1-1">
                    <div class="uk-margin">
                        <label hidden={!get(this.errors, 'postcode.message')} class="uk-form-label">Postcode <span class="uk-text-danger">{get(this.errors, 'postcode.message')}</span></label>
                        <div class="uk-form-controls">
                            <input class={`uk-input ${get(this.errors, 'postcode') ? 'uk-form-danger' : ''}`} name='postcode' type="text" placeholder="Postcode" onChange={this.onChange.bind(this)} />
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
